import * as React from 'react';
import '../../sass/AnalyticsDashboardComponent.css';
import AppUtils from '../../utils/AppUtils';
import { Fade, Row, Col } from 'react-bootstrap';
import {PieChart, Cell, Pie, BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import AnalyticsChartHeader from './AnalyticsChartHeader';
import {lineChart} from 'react-icons-kit/fa/lineChart'
import ReactTable from "react-table";
import FeatureStatComponent from './dashboardComponents/FeatureStatComponent';
import matchSorter from 'match-sorter'
import { db } from '../../firebase/firebase';
// import ScoreUtils from 'src/utils/ScoreUtils';
// import Analytics from 'src/objects/Analytics';
// import { values } from 'mobx';
import Tag from 'src/objects/Tag';

export default class AnalyticsDashboardComponent extends React.Component<any, any> {
    
    private userDatabaseRef:firebase.database.Reference = db.app.database().ref("users");

    constructor(props:any) {
        super(props);

        this.state = {
            mainMenuSetting: "Percent",
            chapterChartSetting: "Percent",
            chapterChartChapter: "Chapter",
            chapterChartChapterId: 0,
            visible: false,
            chartInfoExpanded: false,
            analyticsPercentData: [],
            analyticsData: [],
            performanceData: [],
            pieData: [],
            gameplayPieOuterData: [],
            gameplayPieInnerData: [],
            performanceDataPercent: [],
            userData: [],
            analytics: {
                behaviour: {
                    ratio: [
                        {name: 'Chapter 1', positive: 12, negative: 34},
                        {name: 'Chapter 2', uv: 2, pv: 56},
                        {name: 'Chapter 3', uv: -17, pv: -87},
                        {name: 'Chapter 4', uv: 45, pv: 56},
                        {name: 'Chapter 5', uv: 11, pv: 76},
                        {name: 'Chapter 6', uv: 34, pv: 43},
                        {name: 'Chapter 7', uv: 57, pv: 94},
                    ]
                }
            }
        }

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.getChapterChartData = this.getChapterChartData.bind(this);
        this.getTagsChartData = this.getTagsChartData.bind(this);

        // this.props.analyticsDatabaseRef.on('value', this.onAnalyticsDatabaseUpdated);
       this.getAnalyticsData();
       this.getUserData();
    }

    private getUserData() {
        this.userDatabaseRef.once('value', (snapshot) => {
            let data = [];
            snapshot.forEach((child) => {
                let val = child.val()
                // console.log(val)
                let positiveTotal = 0;
                let negativeTotal = 0;
                let decisions = 0;
                let uplift = 0;
                let gameplays = 0;
                let completions = 0;
                let ended = 0;
                if (val.analytics != null) {
                    let analytics:any = JSON.parse(val.analytics);
                    positiveTotal = analytics.p;
                    negativeTotal = analytics.n;
                    decisions = analytics.d;
                    uplift = analytics.u;
                    gameplays = analytics.g;
                    completions = analytics.c;
                    ended = analytics.e;
                }
                let dataSegment = {
                    firstName: val.firstName,
                    lastName: val.lastName,
                    positiveTotal: positiveTotal,
                    negativeTotal: negativeTotal,
                    decisions: decisions,
                    uplift: uplift,
                    gameplays: gameplays,
                    completions: completions,
                    highscore: val.highscore,
                    ended: ended,
                }
                data.push(dataSegment);
            });
            //console.log("N",data[0].name)
            this.setState({userData: data});
        })
    }

    private getAnalyticsData() {
        this.props.analyticsDatabaseRef.once('value', (snapshot) => {
            let percentData = [];
            let data = [];
            let performanceData = [];
            let performanceDataPercent = [];
            let pieData = [];
            let gameplayPieOuterData = [];
            let gameplayPieInnerData = [];
            snapshot.forEach((child) => {
                let val = child.val()
                // console.log(val.name, val.positiveLarge)
                // let averagePerformance = (
                //     (ScoreUtils.impactStatValues.huge * (val.positiveHuge+1)) +
                //     (ScoreUtils.impactStatValues.large * (val.positiveLarge+1)) +
                //     (ScoreUtils.impactStatValues.medium * (val.positiveMedium+1)) +
                //     (ScoreUtils.impactStatValues.small * (val.positiveSmall+1)) +
                //     (val.neutralTotal + 1)
                // ) / val.decisions;
                // let analytics:Analytics = new Analytics();
                // analytics = {...val}
                // // console.log("A:", analytics)
                // // const {analytics:Analytics} = {...this.props};
                // let highestPositiveTotal = (
                //     (this.props.settings.impactStatValues.huge * (val.positiveHuge)) +
                //     (this.props.settings.impactStatValues.large * (val.positiveLarge)) +
                //     (this.props.settings.impactStatValues.medium * (val.positiveMedium)) +
                //     (this.props.settings.impactStatValues.small * (val.positiveSmall)) +
                //     (this.props.settings.impactStatValues.tiny * (val.positiveTiny))
                // );
                // let highestNegativeTotal = (
                //     (this.props.settings.impactStatValues.huge * (val.negativeHuge)) +
                //     (this.props.settings.impactStatValues.large * (val.negativeLarge)) +
                //     (this.props.settings.impactStatValues.medium * (val.negativeMedium)) +
                //     (this.props.settings.impactStatValues.small * (val.negativeSmall)) +
                //     (this.props.settings.impactStatValues.tiny * (val.negativeTiny))
                // );

                // let averagePerformance = (highestPositiveTotal + highestNegativeTotal);

                // averagePerformance = Math.round(averagePerformance)
                // // console.log("N:",val.positiveSmall, val.positiveSmall+1, val.positiveTiny+1, (val.decisions - (val.positiveTotal + val.negativeTotal)));
                // console.log("AP:",averagePerformance, this.props.settings.impactStatValues.huge * (val.positiveHuge));

                let tagsArray:Array<Tag> = [];
                let tagsArrayPercent:Array<Tag> = [];
                if (val.tags != null) {
                    tagsArray = Object.keys(val.tags).map(function(key) {
                        let tag:Tag = new Tag();
                        tag.name = key.toString();
                        if (val.tags[key].negativeTotal != null) {tag.negativeTotal = val.tags[key].negativeTotal}
                        if (val.tags[key].positiveTotal != null) {tag.positiveTotal = val.tags[key].positiveTotal}
                        // console.log("T",tag, key.toString())
                        return tag;
                    });
                    tagsArrayPercent = Object.keys(val.tags).map(function(key) {
                        let tag:Tag = new Tag();
                        tag.name = key.toString();
                        if (val.tags[key].negativeTotal != null) {tag.negativeTotal = this.getPercentage(val.tags[key].negativeTotal, val.started)}
                        if (val.tags[key].positiveTotal != null) {tag.positiveTotal = this.getPercentage(val.tags[key].positiveTotal, val.started)}
                        // console.log("P:", this.getPercentage(val.positiveTotal, val.started), val.positiveTotal, val.started)
                        return tag;
                    }.bind(this));
                }

                let percentDataSegment = {
                    name: val.name,
                    averagePerformance: 0,
                    neutralTotal: this.getPercentage(val.decisions - (val.positiveTotal + val.negativeTotal), val.decisions),
                    positiveTotal: this.getPercentage(val.positiveTotal, val.decisions),
                    negativeTotal: this.getPercentage(val.negativeTotal, val.decisions),
                    positiveHuge: this.getPercentage(val.positiveHuge, val.decisions),
                    positiveLarge: this.getPercentage(val.positiveLarge, val.decisions),
                    positiveMedium: this.getPercentage(val.positiveMedium, val.decisions),
                    positiveSmall: this.getPercentage(val.positiveSmall, val.decisions),
                    positiveTiny: this.getPercentage(val.positiveTiny, val.decisions),
                    negativeTiny: this.getPercentage(val.negativeTiny, val.decisions),
                    negativeSmall: this.getPercentage(val.negativeSmall, val.decisions),
                    negativeMedium: this.getPercentage(val.negativeMedium, val.decisions),
                    negativeLarge: this.getPercentage(val.negativeLarge, val.decisions),
                    negativeHuge: this.getPercentage(val.negativeHuge, val.decisions),
                    tags: tagsArrayPercent,
                }
                
                let dataSegment = {
                    name: val.name,
                    averagePerformance: 0,
                    neutralTotal: val.decisions - (val.positiveTotal + val.negativeTotal),
                    positiveTotal: val.positiveTotal,
                    negativeTotal: val.negativeTotal,
                    positiveHuge: val.positiveHuge,
                    positiveLarge: val.positiveLarge,
                    positiveMedium: val.positiveMedium,
                    positiveSmall: val.positiveSmall,
                    positiveTiny: val.positiveTiny,
                    negativeTiny: val.negativeTiny,
                    negativeSmall: val.negativeSmall,
                    negativeMedium: val.negativeMedium,
                    negativeLarge: val.negativeLarge,
                    negativeHuge: val.negativeHuge,
                    tags: tagsArray,
                }

                // performance
                // completed
                // replayed

                let performanceSegment = [
                    { subject: 'Huge', positive: val.positiveHuge, negative: val.negativeHuge },
                    { subject: 'Large', positive: val.positiveLarge, negative: val.negativeLarge },
                    { subject: 'Medium', positive: val.positiveMedium, negative: val.negativeMedium },
                    { subject: 'Small', positive: val.positiveSmall, negative: val.negativeSmall },
                    { subject: 'Tiny', positive: val.positiveTiny, negative: val.negativeTiny },
                ];
                let performanceSegmentPercent = [
                    { subject: 'Huge', positive: percentDataSegment.positiveHuge, negative: percentDataSegment.negativeHuge },
                    { subject: 'Large', positive: percentDataSegment.positiveLarge, negative: percentDataSegment.negativeLarge },
                    { subject: 'Medium', positive: percentDataSegment.positiveMedium, negative: percentDataSegment.negativeMedium },
                    { subject: 'Small', positive: percentDataSegment.positiveSmall, negative: percentDataSegment.negativeSmall },
                    { subject: 'Tiny', positive: percentDataSegment.positiveTiny, negative: percentDataSegment.negativeTiny },
                ];
                const pieSegment = [
                    {name: 'Negative Huge', value: val.negativeHuge},
                    {name: 'Negative Huge', value: val.negativeHuge},
                    {name: 'Negative Large', value: val.negativeLarge},
                    {name: 'Negative Medium', value: val.negativeMedium},
                    {name: 'Negative Small', value: val.negativeSmall},
                    {name: 'Negative Tiny', value: val.negativeTiny},
                    {name: 'Neutral', value: val.negativeTiny},
                    {name: 'Positive Tiny', value: val.positiveTiny},
                    {name: 'Positive Small', value: val.positiveSmall},
                    {name: 'Positive Medium', value: val.positiveMedium},
                    {name: 'Positive Large', value: val.positiveLarge},
                    {name: 'Positive Huge', value: val.positiveHuge},
                ];
                const gameplayPieSegmentOuter = [
                    {name: 'Died', value: 67},
                    {name: 'Completed', value: 401},
                ];

                const gameplayPieSegmentInner = [
                    {name: 'Played Once', value: 453},
                    {name: 'Replayed', value: 378},
                ];

                // // pie
                // played once
                // replayed

                // died
                // completed

                // // table
                // averagePerformance
                // positive
                // negative
                // uplift
                // played
                // died
                // completed

                performanceData.push(performanceSegment);
                performanceDataPercent.push(performanceSegmentPercent);
                data.push(dataSegment);
                percentData.push(percentDataSegment);
                pieData.push(pieSegment);
                gameplayPieOuterData.push(gameplayPieSegmentOuter);
                gameplayPieInnerData.push(gameplayPieSegmentInner);
            });
            //console.log("N",data[0].name)
            this.setState({gameplayPieOuterData: gameplayPieOuterData, gameplayPieInnerData: gameplayPieInnerData, pieData:pieData, analyticsPercentData: percentData, performanceDataPercent:performanceDataPercent, performanceData: performanceData, analyticsData: data, chapterChartChapter: data[0].name});
        })
    }

    // private getChapterData():any {
    //     return [this.state.analyticsData[0]]
    // }

    private getPercentage(smallVal, largeVal):any {
        if (largeVal == 0) {largeVal = 1}; // fixes NaN being returned
        let n:number = Math.round((smallVal*100)/largeVal);
        if (n == 0) {
            n = null;
        }
        return n;
    }

    private onAnalyticsDatabaseUpdated(e:any):void {
        console.log("Loaded analytics: ", e.val());
        
        for (const key in e.val()) {
            console.log(key)
        }
    }

    private canShow():boolean {
        if (!AppUtils.isMobile && this.props.isVisible) {
            return true;
        }
        return false;
    }

    private show() {
        this.setState({visible: true})
    }
  
    private hide() {
        this.setState({visible: false})
    }

    private mainChartMenuSelected(setting:string) {this.setState({mainMenuSetting:setting})}
    private chapterChartMenuSelected(setting:string) {this.setState({chapterChartSetting:setting})}
    private chapterChartChapterSelected(setting:string, id:number) {this.setState({chapterChartChapter:setting, chapterChartChapterId: id})}

    private getMainChartData():any {
        let data = this.state.analyticsData;
        if (this.state.mainMenuSetting == "Percent") {
            data = this.state.analyticsPercentData;
        }
        return data;
    }

    private getTagsChartData():any {
        let data = this.state.analyticsData[this.state.chapterChartChapterId];
        if (data != null) {
            let tags = this.state.analyticsData[this.state.chapterChartChapterId].tags
            if (this.state.mainMenuSetting == "Percent") {
                tags = this.state.analyticsPercentData[this.state.chapterChartChapterId].tags;
            }
            return tags;
        } else {
            return []
        }
    }

    private getChapterRadarData():any {
        let data = this.state.performanceData[this.state.chapterChartChapterId];
        if (this.state.chapterChartSetting == "Percent") {
            data = this.state.performanceDataPercent[this.state.chapterChartChapterId];
        }
        return data;
    }

    private getGameplayPieData(ring:string):any {
        let data;
        if (ring == "outer") {
            data = this.state.gameplayPieOuterData[this.state.chapterChartChapterId];
        } else {
            data = this.state.gameplayPieInnerData[this.state.chapterChartChapterId];
        }
        return data;
    }

    private getChapterPieData():any {
        let data = this.state.pieData[this.state.chapterChartChapterId];
        return data;
    }

    private getChapterChartData():any {
        
        let data = [this.state.analyticsData[this.state.chapterChartChapterId]];
        if (this.state.chapterChartSetting == "Percent") {
            data = [this.state.analyticsPercentData[this.state.chapterChartChapterId]];
        }
        return data;
    }

    componentWillUnmount() {
        if (this.props.analyticsDatabaseRef != null) {
            this.props.analyticsDatabaseRef.off();
        }
        if (this.userDatabaseRef != null) {
            this.userDatabaseRef.off();
        }
    }

    render() {
        return (
        <Fade in={this.canShow()} onExited={this.hide} onEntering={this.show}>
          <div id="analyticsDashboardContainer" className="pageContainer" style={{visibility: this.props.isVisible ? 'visible' : 'hidden'}}>

            <div id='mainChart' className='chartContainer'>
                <AnalyticsChartHeader
                    menuItemSelected={this.mainChartMenuSelected.bind(this)}
                    menuSetting={this.state.mainMenuSetting}
                    title="Behaviour"
                    infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                    showPercentMenu={true}
                />
                <div className='chart'>
                    <ResponsiveContainer height={300} width='100%'>
                        <BarChart height={300} data={this.getMainChartData()} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                            <CartesianGrid vertical={false} strokeDasharray="3 3"/>
                            <XAxis stroke='#999' dataKey="name"/>
                            <YAxis type="number" stroke='#999' unit={this.state.mainMenuSetting == "Percent" ? '%' : ''} domain={this.state.mainMenuSetting == "Percent" ? [0, 100] : null}/>
                            <Tooltip/>
                            <Legend />
                            {/* <ReferenceLine y={0} strokeWidth={2} stroke='#ee6666' strokeDasharray="3 3"/> */}
                            
                            <Bar name="Neutral Decisions" dataKey="neutralTotal" fill="#dddddddd" />
                            <Bar name="Positive Decisions" dataKey="positiveTotal" fill="#12C4C4" />
                            <Bar name="Negative Decisions" dataKey="negativeTotal" fill="#E66882" />
                            
                            {/* <Bar name="Positive Influence" dataKey="uv" fill="#12C4C4B3" label={{ position: 'top' }}>
                                {
                                    data.map((entry, index) => (
                                    <Cell key={index} fill={entry.uv > 0 ? "#12C4C4B3":"#ee6666B3"}/>
                                    ))
                                }
                            </Bar> */}
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
            
            <div className="featureStatContainer">
                <Row className="show-grid">
                    <Col xs={6} md={3}><FeatureStatComponent icon={lineChart} stat='+74%' desc='Behavioural Uplift' iconClassName='dPurple' statClassName='lPurple' /></Col>
                    <Col xs={6} md={3}><FeatureStatComponent icon={lineChart} stat='+67%' desc='Confidence Uplift' iconClassName='dGreen' statClassName='lGreen' /></Col>
                    <Col xs={6} md={3}><FeatureStatComponent icon={lineChart} stat='18,623' desc='Decisions' iconClassName='dRed' statClassName='lRed' /></Col>
                    <Col xs={6} md={3}><FeatureStatComponent icon={lineChart} stat='89%' desc='Positive Impact' iconClassName='dBlue' statClassName='lBlue' /></Col>
                </Row>
            </div>

            <div id='mainChart' className='chartContainer'>
                <AnalyticsChartHeader
                    menuItemSelected={this.mainChartMenuSelected.bind(this)}
                    menuSetting={this.state.mainMenuSetting}
                    title="Tags"
                    infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                    showPercentMenu={true}
                />
                <div className='chart'>
                    <ResponsiveContainer height={300} width='100%'>
                        <BarChart height={300} data={this.getTagsChartData()} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                            <CartesianGrid vertical={false} strokeDasharray="3 3"/>
                            <XAxis stroke='#999' dataKey="name"/>
                            <YAxis type="number" stroke='#999' unit={this.state.mainMenuSetting == "Percent" ? '%' : ''} domain={this.state.mainMenuSetting == "Percent" ? [0, 100] : null}/>
                            <Tooltip/>
                            <Legend />
                            {/* <ReferenceLine y={0} strokeWidth={2} stroke='#ee6666' strokeDasharray="3 3"/> */}
                            
                            <Bar name="Positive Decisions" dataKey="positiveTotal" fill="#12C4C4" />
                            {/* <Bar name="Negative Decisions" dataKey="negativeTotal" fill="#E66882" /> */}
                            
                            {/* <Bar name="Positive Influence" dataKey="uv" fill="#12C4C4B3" label={{ position: 'top' }}>
                                {
                                    data.map((entry, index) => (
                                    <Cell key={index} fill={entry.uv > 0 ? "#12C4C4B3":"#ee6666B3"}/>
                                    ))
                                }
                            </Bar> */}
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
            
            {/* <div className='chartContainer'>
                <AnalyticsChartHeader
                    menuItemSelected={this.chapterChartMenuSelected.bind(this)}
                    menuSetting={this.state.chapterChartSetting}
                    chapterItemSelected={this.chapterChartChapterSelected.bind(this)}
                    chapterSetting={this.state.chapterChartChapter}
                    analyticsData={this.state.analyticsData}
                    showChapterMenu={true}
                    showPercentMenu={false}
                    title="Average Performance"
                    infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                />
                <div className='chart'>
                    <ResponsiveContainer height={100} width='100%'>
                        <BarChart 
                            data={this.getChapterChartData()} 
                            layout="vertical"
                            margin={{top: 0, right: 30, left: 35, bottom: 0}}
                            >
                            <XAxis stroke='#999' type="number" domain={this.state.chapterChartSetting == "Percent" ? [this.props.settings.impactStatValues.huge * -1, this.props.settings.impactStatValues.huge] : null}/>
                            <YAxis stroke='#999' hide={true} type="category" dataKey="name" />
                            <CartesianGrid strokeDasharray="3 3"/>
                            <Tooltip/>
                            <Legend />
                            {   this.getChapterChartData() != null && this.getChapterChartData()[0] != null && this.getChapterChartData()[0].averagePerformance > 0 ?
                                
                                <Bar name="Average Performance (%)" unit="%" dataKey="averagePerformance" stackId="a" fill="#12C4C4" /> :
                                <Bar name="Average Performance (%)" unit="%" dataKey="averagePerformance" stackId="a" fill="#E66882" />
                            }
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div> */}

            <div className="halfRowStatContainer">       
                <Row className="show-grid">
                    <Col xs={12} md={6}>
                        <div className='chartContainer'>
                            <AnalyticsChartHeader
                                menuItemSelected={this.chapterChartMenuSelected.bind(this)}
                                menuSetting={this.state.chapterChartSetting}
                                chapterItemSelected={this.chapterChartChapterSelected.bind(this)}
                                chapterSetting={this.state.chapterChartChapter}
                                analyticsData={this.state.analyticsData}
                                showChapterMenu={true}
                                showPercentMenu={false}
                                title="Decisions"
                                infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                            />
                            <div className='chart'>
                                <ResponsiveContainer height={400} width='100%'>
                                    {/* <RadarChart outerRadius={150} width={600} height={400} data={this.getChapterRadarData()}>
                                        <PolarGrid />
                                        <PolarAngleAxis dataKey="subject" />
                                        <PolarRadiusAxis/>
                                        <Radar name="Mike" dataKey="negative" stroke="#E66882" fill="#E66882" fillOpacity={0.6}/>
                                    </RadarChart> */}
                                    <PieChart>
                                        <Pie data={this.getChapterPieData()} dataKey="value" innerRadius={80}>
                                            <Cell name="Catastrophic" dataKey="negativeHuge" stackId="a" fill="#B85368" />
                                            <Cell name="Terrible" dataKey="negativeLarge" stackId="a" fill="#CF5D75" />
                                            <Cell name="Awful" dataKey="negativeMedium" stackId="a" fill="#E66882" />
                                            <Cell name="Bad" dataKey="negativeSmall" stackId="a" fill="#FF7390" />
                                            <Cell name="Poor" dataKey="negativeTiny" stackId="a" fill="#FF899D" />
                                            <Cell name="Neutral" dataKey="neutralTotal" stackId="a" fill="#dddddd" />
                                            <Cell name="Ok" dataKey="positiveTiny" stackId="a" fill="#86D9CD" />
                                            <Cell name="Good" dataKey="positiveSmall" stackId="a" fill="#75BEB3" />
                                            <Cell name="Great" dataKey="positiveMedium" stackId="a" fill="#66A69C" />
                                            <Cell name="Terrific" dataKey="positiveLarge" stackId="a" fill="#5C968D" />
                                            <Cell name="Outstanding" dataKey="positiveHuge" stackId="a" fill="#497770" />
                                        </Pie>
                                        <Tooltip/>
                                        <Legend />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </Col>

                    <Col xs={12} md={6}>
                    <div className='chartContainer'>
                <AnalyticsChartHeader
                    menuItemSelected={this.chapterChartMenuSelected.bind(this)}
                    menuSetting={this.state.chapterChartSetting}
                    chapterItemSelected={this.chapterChartChapterSelected.bind(this)}
                    chapterSetting={this.state.chapterChartChapter}
                    analyticsData={this.state.analyticsData}
                    showChapterMenu={true}
                    showPercentMenu={false}
                    title="Engagement"
                    infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                />
                <div className='chart'>
                <ResponsiveContainer height={400} width='100%'>
                    <PieChart>
                        <Pie data={this.getGameplayPieData("inner")} dataKey="value" innerRadius={105}>
                            <Cell name="Played Once" dataKey="Played Once" stackId="a" fill="#6F69B4" />
                            <Cell name="Replayed" dataKey="Replayed" stackId="a" fill="#5AA5EF" />
                        </Pie>
                        <Pie data={this.getGameplayPieData("outer")} dataKey="value" innerRadius={50} outerRadius={85}>
                            <Cell name="Died" dataKey="Died" stackId="a" fill="#12C4C4" />
                            <Cell name="Completed" dataKey="Completed" stackId="a" fill="#E66882" />
                        </Pie>
                        <Tooltip/>
                        <Legend />
                    </PieChart>
                    </ResponsiveContainer>
                </div>                
            </div>

                    </Col>
                </Row>
            </div> 

            <div className='chartContainer'>
                <AnalyticsChartHeader
                    menuItemSelected={this.mainChartMenuSelected.bind(this)}
                    menuSetting={this.state.mainMenuSetting}
                    title="Chapters"
                    infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                    showPercentMenu={false}
                    showChapterMenu={false}
                />
                <div className='chart'>
                    <ReactTable
                    data={this.state.analyticsData}
                    filterable
                    showPaginationTop={false}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    columns={[
                              {
                                Header: "Name",
                                id: "name",
                                accessor: d => d.name,
                                filterMethod: (filter, rows) =>
                                  matchSorter(rows, filter.value, { keys: ["name"] }),
                                filterAll: true
                              },
                              {
                                Header: "Positive Total",
                                id: "positiveTotal",
                                accessor: d => d.positiveTotal,
                                filterAll: true
                              },
                              {
                                Header: "Negative Total",
                                id: "positiveTotal",
                                accessor: d => d.positiveTotal,
                                filterAll: true
                              },
                              {
                                Header: "Performance",
                                unit: "%",
                                id: "averagePerformance",
                                accessor: d => d.averagePerformance,
                                filterAll: true
                              }
                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight"
                    />
                </div>                
            </div>


            <div className='chartContainer'>
                <AnalyticsChartHeader
                    menuItemSelected={this.mainChartMenuSelected.bind(this)}
                    menuSetting={this.state.mainMenuSetting}
                    title="Learners"
                    infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                    showPercentMenu={false}
                    showChapterMenu={false}
                />
                <div className='chart'>
                    <ReactTable
                    data={this.state.userData}
                    filterable
                    showPaginationTop={false}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    columns={[
                              {
                                Header: "First Name",
                                id: "firstName",
                                accessor: d => d.firstName,
                                filterMethod: (filter, rows) =>
                                  matchSorter(rows, filter.value, { keys: ["firstName"] }),
                                filterAll: true
                              },
                              {
                                Header: "Last Name",
                                id: "lastName",
                                accessor: d => d.lastName,
                                filterMethod: (filter, rows) =>
                                  matchSorter(rows, filter.value, { keys: ["lastName"] }),
                                filterAll: true
                              },
                              {
                                Header: "Decisions",
                                id: "decisions",
                                accessor: d => d.decisions,
                                filterAll: true
                              },
                              {
                                Header: "Started",
                                id: "gameplays",
                                accessor: d => d.gameplays,
                                filterAll: true
                              },
                              {
                                Header: "Completed",
                                id: "completions",
                                accessor: d => d.completions,
                                filterAll: true
                              },
                              {
                                Header: "Died / Failed",
                                id: "ended",
                                accessor: d => d.ended,
                                filterAll: true
                              },
                              {
                                Header: "Best Score",
                                id: "highscore",
                                accessor: d => d.highscore,
                                filterAll: true
                              },
                              {
                                Header: "Uplift",
                                id: "uplift",
                                accessor: d => d.uplift,
                                filterAll: true
                              }
                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight"
                    />
                </div>                
            </div>

            

            {/* <div className="halfRowStatContainer">       
                <Row className="show-grid">
                    <Col xs={6} md={6}>
                        <div id='scatterChart' className='chartContainer'>
                            <AnalyticsChartHeader
                                menuItemSelected={this.mainChartMenuSelected.bind(this)}
                                menuSetting={this.state.mainMenuSetting}
                                title="Conf. vs Prof."
                                infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                            />
                            <div className='chart'>
                                <ResponsiveContainer height={400} width='100%'>
                                <ScatterChart margin={{top: 20, right: 20, bottom: 20, left: 20}}>
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis stroke='#999' type="number" dataKey={'x'} name='Confidence' unit='%'/>
                                    <YAxis stroke='#999' type="number" dataKey={'y'} name='Proficiency' unit='%'/>
                                    <ZAxis dataKey={'z'} range={[60, 400]} name='Uplift' unit='%'/>
                                    <ReferenceLine y={50} strokeWidth={2} stroke='#ee6666' strokeDasharray="3 3"/>
                                    <ReferenceLine x={50} strokeWidth={2} stroke='#ee6666' strokeDasharray="3 3"/>
                                    <CartesianGrid />
                                    <Tooltip cursor={{strokeDasharray: '3 3'}}/>
                                    <Legend />
                                    <Scatter name='Chapters' data={scatterData1} fill='#12C4C4B3' shape="circle"/>
                                </ScatterChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </Col>
                    <Col xs={6} md={6}>
                        <div id='scatterChart' className='chartContainer'>
                            <AnalyticsChartHeader
                                menuItemSelected={this.mainChartMenuSelected.bind(this)}
                                menuSetting={this.state.mainMenuSetting}
                                title="Gameplays"
                                infoText="Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident."
                            />
                            <div className='chart'>
                                <ResponsiveContainer height={400} width='100%'>
                                <LineChart width={600} height={300} data={dataLine} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                                    <XAxis stroke='#999' dataKey="name"/>
                                    <YAxis stroke='#999'/>
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <Tooltip/>
                                    <Legend />
                                    <Line type="monotone" dataKey="unique" stroke="#54B3C6" activeDot={{r: 8}}/>
                                    <Line type="monotone" dataKey="repeat" stroke="#5BC1B3" />
                                </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>  */}

          </div>
        </Fade>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/analytics/AnalyticsDashboardComponent.tsx